import { useQuery } from '@tanstack/react-query'

import { apiGetPaymentMethods } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

export const useGetPaymentMethods = () => {
  return useQuery({
    queryKey: [PAYMENT_KEYS.PAYMENT_METHODS],
    queryFn: apiGetPaymentMethods,
  })
}
